function restoreValueFromCookie(model, field_name, namespace, transformFnIn) {
    let appCookiesEnabled = plannerApplication.cookiesEnabled;

    if (!appCookiesEnabled) {
        return;
    }
    let transformFn = nullIfUndefined(transformFnIn);
    let attribute = namespace + '.' + field_name;
    let cookieValue = Cookies.get(attribute);
    if (cookieValue !== null && cookieValue !== undefined && cookieValue !== 'null') {
        if (transformFn) {
            cookieValue = transformFn(cookieValue);
        }
        model.set(field_name, cookieValue);
    }
}

function storeValueInCookie(model, field_name, namespace) {
    let appCookiesEnabled = plannerApplication.cookiesEnabled;

    if (!appCookiesEnabled) {
        return;
    }

    let attribute = namespace + '.' + field_name;
    Cookies.set(attribute, model.get(field_name), {path: '/', expires: 365});
}


function storeModelInCookie(model, namespace) {
    let appCookiesEnabled = plannerApplication.cookiesEnabled;

    if (!appCookiesEnabled) {
        return;
    }
    let json = model.toJSON();
    let str = JSON.stringify(json);

    let attribute = namespace;
    Cookies.set(attribute, str, {path: '/', expires: 365});
    return json;
}

function restoreJSONFromCookie(attribute) {
    let cookieValue = Cookies.get(attribute);
    if (cookieValue !== null && cookieValue !== undefined && cookieValue !== 'null') {
        let json = JSON.parse(cookieValue);
        return json;
    }
    return null;
}
